import { AnalyticsApiService } from './analytics-api/analytics-api.service';
import { ApiService } from './api/api.service';
import { BackendService } from './backend/backend.service';
import { BenchmarkService } from './benchmark/benchmark.service';
import { BenchmarkServiceMock } from './benchmark/benchmark.service.mock';
import { BreadcrumbsService } from './breadcrumbs/breadcrumbs.service';
import { Cache } from './cache/cache.service';
import { ColorService } from './color/color.service';
import { DebounceService } from './debounce/debounce.service';
import { FilterService } from './filter/filter.service';
import { HubEventsService } from './hub-events/hub-events.service';
import { LoaderService } from './loader/loader.service';
import { Logger } from './logger/logger.service';
import { MessageService } from './message/message.service';
import { MigrationService } from './migration/migration.service';
import { QueryMigrationService } from './migration/query-migration.service';
import { GlobalMigrationService } from './migration/global-migration.service';
import { ModalService } from './modal/modal.service';
import { NotificationsService } from './notifications/notifications.service';
import { PusherService } from './notifications/pusher.service';
import { ObjectBaseService } from './object-base/object-base.service';
import { PublicLinkService } from './public-link/public-link.service';
import { QueryService } from './query/query.service';
import { SessionService } from './session/session.service';
import { SharedObjectBaseService } from './shared-object-base/shared-object-base.service';
import { SegmentService } from './tracking/segment.service';
import { TrackingService } from './tracking/tracking.service';
import { WrapMiddleService } from './wrap-middle/wrap-middle.service';
import { PostMessageService } from './post-message/post-message.service';

export const SERVICES: any[] = [
  AnalyticsApiService,
  ApiService,
  BackendService,
  BenchmarkService,
  BenchmarkServiceMock,
  BreadcrumbsService,
  Cache,
  ColorService,
  DebounceService,
  HubEventsService,
  LoaderService,
  Logger,
  MessageService,
  MigrationService,
  QueryMigrationService,
  GlobalMigrationService,
  ModalService,
  NotificationsService,
  PusherService,
  ObjectBaseService,
  PublicLinkService,
  QueryService,
  SessionService,
  SharedObjectBaseService,
  SegmentService,
  TrackingService,
  WrapMiddleService,
  PostMessageService,
  FilterService,
];
